export const darkTheme = {
    palette: {
      mode: 'dark',
      primary: {
        main: "#FFA500",
        light: "#FFB74D",
        dark: "#FF9800",
        contrastText: "#fff",
      },
      secondary: {
        main: "#FF8A65",
      },
      background: {
        default: "#121212",
        paper: "#1E1E1E",
      },
      text: {
        primary: "#fff",
        secondary: "#B0BEC5",
      },
      action: {
        active: '#fff',
        hover: 'rgba(255, 255, 255, 0.08)',
        selected: 'rgba(255, 255, 255, 0.16)',
        disabled: 'rgba(255, 255, 255, 0.3)',
      },
    },
    typography: {
      fontFamily: "Poppins, Arial, sans-serif",
      h1: {
        color: "#FFA500",
        fontSize: "2.5rem",
      },
      h2: {
        color: "#FFA500",
        fontSize: "2rem",
      },
      body1: {
        fontSize: "1rem",
      },
      body2: {
        fontSize: "0.875rem",
      },
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: "#1E1E1E", // Dark app bar
            color: "#FFA500",
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            '&:hover': {
              backgroundColor: 'rgba(255, 165, 0, 0.1)',
            },
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          dense: {
            minHeight: "48px !important",
          },
        },
      },
    },
  };
  